/**
 * screens/Approvals/emptyState.ts
 * Copy for the approvals panel. An empty queue is good news, so the panel
 * explains what would put something in it rather than apologising.
 */
import type { FlowNode, Step } from '../../components/EmptyState';

export const APPROVALS_FLOW: readonly FlowNode[] = [
  { key: 'record', label: 'Record', sub: 'a spend is logged' },
  { key: 'match', label: 'Match', sub: 'against the rules', here: true },
  { key: 'decide', label: 'Decide', sub: 'approve or reject' },
  { key: 'release', label: 'Release', sub: 'the money moves' },
];

export const APPROVALS_STEPS: readonly Step[] = [
  {
    n: '1',
    label: 'A rule holds the spend',
    hint: 'Amount, category, holder type, instrument, or a missing receipt.',
  },
  {
    n: '2',
    label: 'The named approvers decide',
    hint: 'Two approvers means both must approve; one approval leaves it pending.',
  },
  {
    n: '3',
    label: 'A rejection carries a reason',
    hint: 'The requester sees exactly why, in their own ledger.',
  },
];

export const APPROVALS_COPY = {
  eyebrow: 'Approvals',
  title: 'Nothing is waiting for a decision',
  blurb:
    'Spends are held only when a rule says so. Everything under the auto-approve floor goes straight through, whatever the rules say.',
  flowNote:
    'The approval threshold and the dual-approval ceiling are not hidden numbers — saving them creates rules you can see and edit in Settings.',
  footNote: 'Approval rules decide what reaches this queue.',
} as const;
